var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-holder"},[_c('lottie-animation',{staticClass:"loader-icon",attrs:{"path":"../preloader.json","width":80,"height":80}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }